var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1 pt-1 pb-2"},[_c('EmbedForm',{attrs:{"params":_vm.$route.query,"buyable":_vm.training},on:{"change":_vm.postDimensions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }